<template>
  <div id="app">
    <!--顶部nav-->
    <div class="topCommon">
      <div class="logo">
        <img src="@/assets/images/logo.png" alt="" />
      </div>
    </div>
    <div v-if="nav">
      <div class="topBox">
        <div class="typeBox">
          <img
            src="@/assets/images/zsy_icon_01.png"
            alt=""
            style="transform: none; cursor: auto"
          />
          <img
            src="@/assets/images/0445_03.jpg"
            alt=""
            @click="jump('index')"
          />

          <img src="@/assets/images/0445_05.jpg" alt="" @click="jump('szyw')" />
          <img src="@/assets/images/0445_09.jpg" alt="" @click="jump('gfjj')" />
          <img src="@/assets/images/0445_11.jpg" alt="" @click="jump('hyss')" />
          <img
            src="@/assets/images/0445_13.jpg"
            alt=""
            @click="jump('qyqcss')"
          />
          <img src="@/assets/images/0445_15.jpg" alt="" @click="jump('sgcy')" />
          <img src="@/assets/images/0445_17.jpg" alt="" @click="jump('kjcy')" />
          <img src="@/assets/images/0445_19.jpg" alt="" @click="jump('ssyh')" />
          <img
            src="@/assets/images/0445_07.jpg"
            alt=""
            @click="jump('jckss')"
          />
        </div>
        <div class="search" style="position: relative">
          <!--搜索联想-->
          <div class="searchLenovo" v-if="searchText !== ''">
            <div class="sLevovoTitle">搜索联想</div>
            <div class="sLevovoKey">{{ searchText }}:</div>
            <div class="sLevovoRight">
              <div class="sLenovoScroll" v-if="lenovoList.length != 0">
                <template v-for="(item, index) in lenovoList">
                  <span
                    @click="lenovoCheck(item)"
                    class="textList"
                    v-html="item.highlight"
                    :key="index"
                  ></span>
                </template>
              </div>
              <div class="sLenovoScroll" v-if="lenovoList.length == 0">
                未获取检索联想词
              </div>
            </div>
          </div>
          <!--搜索历史-->
          <div class="searchHistory" v-if="searchText === ''">
            <div class="sHistoryTitle">111最近搜索:</div>
            <div class="sHistoryRight">
              <div class="sHistoryScroll" v-if="historyList.length != 0">
                <template v-for="(item, index) in historyList">
                  <span
                    @click="historyClick(item)"
                    class="textListHistory"
                    v-html="item"
                    :key="index"
                  ></span>
                </template>
              </div>
              <div class="sHistoryScroll" v-if="historyList.length == 0">
                暂无最近搜索记录1
              </div>
            </div>
          </div>
          <div>
            <el-input
              v-model="input"
              @input="fillHotWords()"
              placeholder="请输入要搜索的关键词，两个以上关键词用空格分开"
              class="searchInput"
            ></el-input>
            <el-button type="primary" class="searchType" @click="searchFun(1)"
              >按正文<span style="color: #ffe200; padding-left: 5px"
                >全面搜索</span
              ></el-button
            >
            <el-button type="primary" class="searchType" @click="searchFun(2)"
              >按标题<span style="color: #ffe200; padding-left: 5px"
                >极速搜索</span
              ></el-button
            >
            <el-button type="primary" class="searchType" @click="searchFun(3)"
              >按文号<span style="color: #ffe200; padding-left: 5px"
                >特定搜索</span
              ></el-button
            >
          </div>
        </div>
      </div>
      <!-- 9.12文档 1. -->
      <!-- <div style="width: 100%; background: #f5f5f5; padding: 20px 0 0 0">
        <div class="banner">
          <img src="@/assets/images/00_banner_1200px_120px.png" alt="" />
        </div>
      </div> -->
    </div>
    <el-drawer title="我的检索条件记录" :visible.sync="drawer" size="870px">
      <div
        style="
          width: 780px;
          height: 45px;
          background: #f5f5f5;
          line-height: 45px;
          font-size: 18px;
          margin-bottom: 10px;
          margin: 0 auto;
        "
      >
        <span style="margin-left: 15px">检索条件</span>
      </div>
      <div
        class="jsList"
        style="padding-left: 15px; width: calc(780px); margin: 10px auto 0"
      >
        <div v-for="item in this.consultList" style="line-height: 50px">
          <div
            style="
              font-size: 16px;
              color: #333;
              display: inline-block;
              width: 600px;
              line-height: 1.5;
            "
          >
            <span
              v-for="(items, index) in item.tag"
              style="font-size: 16px; margin-right: 5px"
            >
              {{ items.type | searchTypeFl }}{{ index + 1 }}:{{ items.name }}
            </span>
            <span v-if="item.type">分类</span>
          </div>
          <div
            style="
              float: right;
              display: inline-block;
              width: 80px;
              height: 36px;
              background: #0f59a4;
              text-align: center;
              line-height: 36px;
              color: #fff;
              cursor: pointer;
            "
            @click="addFun3(item)"
          >
            检索
          </div>
        </div>
      </div>
    </el-drawer>
    <div class="midCommon">
      <div class="area">
        <!-- 23.01.03 更新文档要求删除 -->
        <!-- <div class="antistop">
          <img src="@/assets/images/01_keyword_105px_48px.png" alt="" />
          <div class="tagBox">
            <span v-for="item in keyWordList" :key="item.text" @click="keyWordFun(item.text)">{{
              item.text
            }}</span>
          </div>
        </div> -->
        <div class="searchBox" v-if="tags != false">
          <span
            style="
              font-size: 16px;
              color: #0f59a4;
              margin-right: 15px;
              line-height: 60px;
              font-weight: 700;
              vertical-align: top;
            "
            >检索条件：</span
          >
          <div style="width: 700px; display: inline-block">
            <el-tag
              style="margin: 14px"
              v-for="(item, index) in tags"
              :key="index"
              type="info"
              effect="plain"
              closable
              @close="tagEmpty()"
              >{{ item.type | searchTypeFl }}{{ index + 1 }}：
              {{ item.name }}
            </el-tag>
          </div>
          <div style="float: right">
            <!-- <span style="font-size:16px;color:#333;line-height:60px;margin-right:40px">
          共<span style="color:#c22424">125</span>条数据
        </span> -->
            <!-- 记录保存 -->
            <span
              style="
                font-size: 16px;
                line-height: 60px;
                color: #0f59a4;
                margin-right: 5px;
              "
            >
              共 <span style="color: #ce5959">{{ searchTotal }}条</span> 数据
            </span>
            <span
              @click="addFun()"
              style="
                font-size: 16px;
                line-height: 60px;
                color: #0f59a4;
                cursor: pointer;
                margin-right: 5px;
              "
            >
              <i class="el-icon-document" style="margin-right: 8px"></i>
              <span>记录</span>
            </span>
            <span
              @click="addFun2()"
              style="
                font-size: 16px;
                line-height: 60px;
                color: #0f59a4;
                cursor: pointer;
                margin-right: 5px;
              "
            >
              <i class="el-icon-edit-outline" style="margin-right: 8px"></i>
              <span>保存</span>
            </span>
            <!-- 记录保存 -->
            <span
              @click="tagEmpty()"
              style="
                font-size: 16px;
                line-height: 60px;
                color: #f00;
                cursor: pointer;
              "
            >
              <i class="el-icon-delete" style="margin-right: 8px"></i>
              <span>清空</span>
            </span>
          </div>
        </div>
        <div class="contentBox">
          <!-- 法规标签树 -->
          <div class="treeBox">
            <div class="boxTitle">
              法规<span class="typeTotal">({{ fgList.count }})</span>
            </div>
            <div class="treeTypeBox">
              <!-- <div v-for="item in 8">
            <div class="typeTitleBox">
              <span class="title">法规xxxx</span>
              <span class="typeTotal">(124578)</span>
              <span class="open">展开</span>
            </div>
          </div> -->
              <!-- 标签树 -->
              <div class="tree_container">
                <el-tree
                  class="show-tree"
                  ref="eltree"
                  :data="fgList.childs"
                  :props="defaultProps"
                  :render-content="renderContent"
                  :highlight-current="true"
                  node-key="id"
                  :default-expanded-keys="treeExpandData"
                  :current-node-key="keyId"
                  @node-click="handleNodeClick"
                >
                  <!-- highlight-current 高亮显示 不让背景消失  如果想取消选中也可以在某个事件上为false就可以随着点击事件取消高亮 -->
                </el-tree>
              </div>
            </div>
          </div>
          <div class="rightBox">
            <div class="zjgd">
              <div class="boxTitle">
                特约专家观点<span class="typeTotal"
                  >({{ tyzjList.count }})</span
                >
                <div class="more" @click="listJump(tyzjList.id)">更多>></div>
              </div>
              <div class="list">
                <ul>
                  <li v-for="item in tyzjList.contents" :key="item.id">
                    <span
                      class="title"
                      v-html="item.title"
                      @click="contentJump(item.id)"
                    ></span>
                    <span class="time">{{
                      item.publishDate | formatDate
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="DyAndJd">
              <div class="dy">
                <div class="boxTitle">
                  答疑<span class="typeTotal">({{ dyList.count }})</span>
                </div>
                <div class="list" v-for="item in dyList.childs" :key="item.id">
                  <div class="typeTitle">
                    {{ item.name
                    }}<span class="typeTotal">({{ item.count }})</span>
                    <div class="more" @click="listJump(item.id)">更多>></div>
                  </div>
                  <ul>
                    <li v-for="item in item.contents" :key="item.id">
                      <span
                        class="title"
                        v-html="item.title"
                        @click="contentJump(item.id)"
                      ></span>
                    </li>
                    <div
                      style="text-align: center; color: #f00; padding: 10px 0"
                      v-if="item.contents == false"
                    >
                      暂无数据
                    </div>
                  </ul>
                </div>
              </div>
              <div class="jd">
                <div class="boxTitle">
                  解读<span class="typeTotal">({{ jdList.count }})</span>
                </div>
                <div class="list" v-for="item in jdList.childs" :key="item.id">
                  <div class="typeTitle">
                    {{ item.name
                    }}<span class="typeTotal">({{ item.count }})</span>
                    <div class="more" @click="listJump(item.id)">更多>></div>
                  </div>
                  <ul>
                    <li v-for="item in item.contents" :key="item.id">
                      <span
                        class="title"
                        v-html="item.title"
                        @click="JdJump(item)"
                      ></span>
                    </li>
                    <div
                      style="text-align: center; color: #f00; padding: 10px 0"
                      v-if="item.contents == false"
                    >
                      暂无数据
                    </div>
                  </ul>
                </div>
              </div>
              <div class="zt">
                <div class="boxTitle">
                  专题<span class="typeTotal">({{ ztList.count }})</span>
                  <!-- <div class="more" @click="listJump(jjkcList.id)">更多>></div> -->
                </div>
                <div class="list" v-for="item in ztList.childs" :key="item.id">
                  <div class="typeTitle">
                    {{ item.name
                    }}<span class="typeTotal">({{ item.count }})</span>
                    <div class="more" @click="listJump(item.id)">更多>></div>
                  </div>
                  <ul>
                    <li v-for="item in item.contents" :key="item.id">
                      <span
                        class="title"
                        v-html="item.title"
                        @click="contentJump(item.id)"
                      ></span>
                    </li>
                    <div
                      style="text-align: center; color: #f00; padding: 10px 0"
                      v-if="item.contents == false"
                    >
                      暂无数据
                    </div>
                  </ul>
                </div>
              </div>
              <!-- ----------------------------- -->
              <!-- <div class="jjkc">
                <div class="boxTitle">
                  研发费用加计扣除<span class="typeTotal"
                    >({{ jjkcList.count }})</span
                  >
                  <div class="more" @click="listJump(jjkcList.id)">更多>></div>
                </div>
                <div class="list">
                  <ul>
                    <li v-for="item in jjkcList.contents">
                      <span
                        class="title"
                        v-html="item.title"
                        @click="contentJump(item.id)"
                      ></span>
                    </li>
                    <div
                      style="text-align: center; color: #f00; padding: 10px 0"
                      v-if="jjkcList.contents == false"
                    >
                      暂无数据
                    </div>
                  </ul>
                </div>
              </div>
              <div class="tdqs">
                <div class="boxTitle">
                  土地增值税清算<span class="typeTotal"
                    >({{ tdqsList.count }})</span
                  >
                  <div class="more" @click="listJump(tdqsList.id)">更多>></div>
                </div>
                <div class="list">
                  <ul>
                    <li
                      v-for="item in tdqsList.contents"
                      @click="contentJump(item.id)"
                    >
                      <span class="title" v-html="item.title"></span>
                    </li>
                    <div
                      style="text-align: center; color: #f00; padding: 10px 0"
                      v-if="tdqsList.contents == false"
                    >
                      暂无数据
                    </div>
                  </ul>
                </div>
              </div>
              <div class="jcdl">
                <div class="boxTitle">
                  集成电路企业和软件企业<span class="typeTotal"
                    >({{ jcdlList.count }})</span
                  >
                  <div class="more" @click="listJump(jcdlList.id)">更多>></div>
                </div>
                <div class="list">
                  <ul>
                    <li v-for="item in jcdlList.contents">
                      <span
                        class="title"
                        v-html="item.title"
                        @click="contentJump(item.id)"
                      ></span>
                    </li>
                    <div
                      style="text-align: center; color: #f00; padding: 10px 0"
                      v-if="jcdlList.contents == false"
                    >
                      暂无数据
                    </div>
                  </ul>
                </div>
              </div>
              <div class="xwqy">
                <div class="boxTitle">
                  小微企业和个体工商户<span class="typeTotal"
                    >({{ xwqyList.count }})</span
                  >
                  <div class="more" @click="listJump(xwqyList.id)">更多>></div>
                </div>
                <div class="list">
                  <ul>
                    <li v-for="item in xwqyList.contents">
                      <span
                        class="title"
                        v-html="item.title"
                        @click="contentJump(item.id)"
                      ></span>
                    </li>
                    <div
                      style="text-align: center; color: #f00; padding: 10px 0"
                      v-if="xwqyList.contents == false"
                    >
                      暂无数据
                    </div>
                  </ul>
                </div>
              </div>
              <div class="zhssf">
                <div class="boxTitle">
                  组合式税费<span class="typeTotal"
                    >({{ zhssfList.count }})</span
                  >
                  <div class="more" @click="listJump(zhssfList.id)">更多>></div>
                </div>
                <div class="list">
                  <ul>
                    <li v-for="item in zhssfList.contents">
                      <span
                        class="title"
                        v-html="item.title"
                        @click="contentJump(item.id)"
                      ></span>
                    </li>
                    <div
                      style="text-align: center; color: #f00; padding: 10px 0"
                      v-if="zhssfList.contents == false"
                    >
                      暂无数据
                    </div>
                  </ul>
                </div>
              </div>
              <div class="gxjsqy">
                <div class="boxTitle">
                  高新技术企业<span class="typeTotal"
                    >({{ gxjsList.count }})</span
                  >
                  <div class="more" @click="listJump(gxjsList.id)">更多>></div>
                </div>
                <div class="list">
                  <ul>
                    <li v-for="item in gxjsList.contents">
                      <span
                        class="title"
                        v-html="item.title"
                        @click="contentJump(item.id)"
                      ></span>
                    </li>
                    <div
                      style="text-align: center; color: #f00; padding: 10px 0"
                      v-if="gxjsList.contents == false"
                    >
                      暂无数据
                    </div>
                  </ul>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footCommon">网站版权信息</div>
  </div>
</template>

<script>
//节流
import { debounce } from "lodash";

import {
  tagTreeCache,
  dictionaryDataList,
  HomeLaw,
  keyLenovo,
  HomeAnalyzeKeyword,
} from "@/api/api";
import addImg from "@/assets/images/03_add_12px_12px.png";
import subImg from "@/assets/images/02_sub_12px_12px.png";
export default {
  name: "index",
  data() {
    return {
      inputList: [],
      searchTotal: 0,
      loading: "",
      index: "",
      input: "",
      drawer: false,
      nav: true,
      loading: "",
      consultList: [],
      tags: [
        // {name:'增值税'}
      ],
      tagList: [],
      // 法规
      fgList: [],
      // 特约专家
      tyzjList: [],
      // 答疑
      dyList: [],
      // 解读
      jdList: [],
      // 加计扣除
      ztList: [],
      // 关键词
      keyWordList: [],
      // 标签树
      treeData: [],
      defaultProps: {
        //el-tree 树结构默认渲染的字段
        children: "tags",
        label: "name",
        isLeaf: "isLeaf", //isLeaf在tree组件里面算是判断有没有子集 相当于可以控制三角显示▶️
      },
      searchText: "",
      searchType: 1,
      crumbslist: [],
      treeExpandData: [], //自己定义的用于接收tree树id的数组
      //选择的联想词
      searchText: "",
      //联想词列表
      lenovoList: [],
      //历史检索
      historyList: [],
    };
  },
  filters: {
    formatDate(time) {
      if (typeof time == "number") {
        try {
          var date = new Date(time);
          var Y = date.getFullYear() + "-";
          var M =
            (date.getMonth() + 1 < 10
              ? "0" + (date.getMonth() + 1)
              : date.getMonth() + 1) + "-";
          var D = date.getDate() + " ";
          return Y + M + D;
        } catch (e) {
          console.log(time);
          return time;
        }
      } else {
        return time.slice(0, 10);
      }
    },
    searchTypeFl(v) {
      let a = "";
      switch (v) {
        case 2:
          a = "标题";
          break;
        case 3:
          a = "文号";
          break;
        default:
          a = "全文";
          break;
      }
      return a;
    },
  },
  created() {
    //获取最近搜索
    this.getSearchHistory();

    this.loading = this.$loading({
      lock: true,
      text: "拼命加载中",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    // debugger
    if (this.$route.query.keyword && this.$route.query.keyword != false) {
      this.input = this.$route.query.keyword;
      this.searchType = this.$route.query.searchType;
      this.HomeAnalyzeKeyword();
      // this.tags = [{ name: this.input ,type:this.$route.query.searchType}];
    }
    this.tree();
    this.dictionaryDataList();
    this.HomeLaw();
  },
  methods: {
    addFun() {
      this.drawer = true;
      this.consultList = JSON.parse(localStorage.getItem("table"));

      // let typeText = '';
      // this.consultList.forEach(el => {
      //   let name = '';
      //   el.tag.forEach(element => {
      //     name += element.name+' '
      //   });
      //   el.name = name;
      //   el.type = el.tag[0].type;
      // })
      console.log(this.consultList);
    },
    addFun2() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      let time = year + "-" + month + "-" + day;
      let info = {
        tag: this.tags,
        time: time,
        inputId: this.searchType,
      };
      let list = [];
      if (localStorage.getItem("table")) {
        list = JSON.parse(localStorage.getItem("table"));
      }
      if (list.length == 5) {
        list.pop();
      }
      list.unshift(info);
      localStorage.setItem("table", JSON.stringify(list));
    },
    addFun3(v) {
      console.log(v);
      if (v.type) {
      } else {
        let a = "";
        v.tag.forEach((element) => {
          a += element.name + " ";
        });
        this.input = a;
        this.searchType = v.tag[0].type;
        this.searchFun(this.searchType);
      }
      this.drawer = false;
    },
    HomeAnalyzeKeyword() {
      this.tags = [];
      let data = {
        keyword: this.input,
      };
      HomeAnalyzeKeyword(data).then((res) => {
        console.log(res.data.data);
        this.inputList = res.data.data;
        for (let i = 0; i < this.inputList.length; i++) {
          const element = { name: this.inputList[i], type: this.searchType };
          this.tags.push(element);
        }
        console.log(this.tags);
      });
    },
    jump(v) {
      let url = process.env.VUE_APP_ZSG_URL + v;
      window.open(url, "_blank");
    },
    JdJump(v) {
      if (v.categoryId == "3735") {
        window.open(v.url, "_blank");
      } else {
        this.contentJump(v.id);
      }
    },
    listJump(v) {
      let Detail = this.$router.resolve({
        path: "/list",
        query: { id: v, keyWord: this.input, searchType: this.searchType },
      });
      window.open(Detail.href, "_blank");
    },
    aboutJump(v) {
      this.$router.push({
        path: "/about",
        query: {
          name: v.name,
          id: v.id,
          keyWord: this.input,
          searchType: this.searchType,
          count: v.count,
        },
      });
    },
    contentJump(v) {
      let Detail = this.$router.resolve({
        path: "/content",
        query: { contentId: v, keyWord: this.input },
      });
      window.open(Detail.href, "_blank");
    },
    searchFun(v) {
      let str = this.input + "";
      this.addSearchHistory(str);

      this.HomeAnalyzeKeyword();
      this.loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.searchType = v;
      if (this.input) {
        this.tags = [{ name: this.input }];
      }
      this.HomeLaw();
    },
    HomeLaw() {
      let data = {
        content: "",
        articleNo: "",
        title: "",
      };
      // debugger
      if (this.input) {
        this.searchType = Number(this.searchType);
        switch (this.searchType) {
          case 1:
            data.content = this.input;
            break;
          case 2:
            data.title = this.input;
            break;
          case 3:
            data.articleNo = this.input;
            break;
        }
      } else {
        this.tags = [];
      }
      HomeLaw(data).then((res) => {
        console.log(res.data.data);
        this.fgList = res.data.data[0];
        this.fgList.childs.forEach((element) => {
          if (element.tags != false) {
            element.tags.forEach((ele) => {
              ele.tags = ele.children;
            });
          } else {
            // element.tags = [{name:'暂无数据'}]
          }
        });
        this.$store.commit("getFgList", this.fgList);
        console.log(this.fgList);
        this.tyzjList = res.data.data[1];
        this.dyList = res.data.data[2];
        this.jdList = res.data.data[3];
        this.ztList = res.data.data[4];
        let count = 0;
        this.ztList.childs.forEach((el) => {
          count += el.count;
        });
        this.ztList.count = count;
        console.log(this.ztList);
        this.searchTotal =
          this.fgList.count +
          this.tyzjList.count +
          this.dyList.count +
          this.jdList.count +
          this.ztList.count;
        // this.searchType = 1;
        this.loading.close();
      });
    },
    keyWordFun(v) {
      // 关键词点击进行搜索
      this.input = v;
      this.tags = [{ name: this.input }];
      this.HomeLaw();
      this.loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    dictionaryDataList() {
      let data = {
        dictionaryId: "zhzsk_fgzspt_keyword",
      };
      dictionaryDataList(data).then((res) => {
        console.log(res);
        this.keyWordList = res.data.list;
      });
    },
    tagEmpty() {
      this.tags = [];
      this.input = "";
      this.HomeLaw();
      this.loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    numberFun(v) {
      for (let i = 0; i < v.length; i++) {
        let element = v[i];
        element.name = i + 1 + "." + element.name;
        // if(v[i].children == null){
        //   // return
        // }else{
        //   this.numberFun(v[i].children)
        // }
      }
    },
    tree() {
      let data = {
        rootId: "6557331",
        typeIds: "",
      };
      tagTreeCache(data).then((res) => {
        console.log(res);
        this.treeData = res.data.data.children;
        // this.numberFun(this.treeData)
        this.getEquipmentList();
        // this.dataSearch();
      });
    },
    crumbsFun(v) {
      if (v.parent != null) {
        this.crumbslist.unshift(v.data.name);
        this.crumbsFun(v.parent);
      } else {
        console.log(this.list);
      }
    },
    // 获取树形结构默认展开节点
    getRoleTreeRootNode(provincialCenterId) {
      this.treeExpandData.push(provincialCenterId);
    },
    //获取tree树列表
    getEquipmentList(params) {
      console.log(this.treeData);
      this.keyId = this.treeData[0].children[0].id; //默认选中节点
      this.$nextTick(() => {
        this.$refs.eltree.setCurrentKey(this.keyId);
      });
      this.tagTreeId = this.keyId;
      this.name = this.treeData[0].children[0].name;
      this.crumbslist.unshift(
        this.treeData[0].name,
        this.treeData[0].children[0].name
      ); //默认面包屑
      this.provincialCenterId = this.treeData[0].id; //默认展开第一个节点
      this.getRoleTreeRootNode(this.provincialCenterId);
      if (this.treeData[0].children[0].children) {
        //判断选中节点是否存在子节点 如果存在展开当前选中节点
        this.getRoleTreeRootNode(this.keyId);
      }
    },
    handleNodeClick(data, node) {
      console.log(data);
      console.log(node);
      this.crumbslist = [];
      this.crumbsFun(node);
      this.tagTreeId = data.id;
      this.name = data.name;
      this.list = [];
      this.page = 1;
      console.log(this.fgList);
      let idList = {
        name: "",
        id: "",
        childs: [],
      };
      idList.name = this.fgList.name;
      idList.id = this.fgList.id;
      this.fgList.childs.forEach((element) => {
        idList.childs.push(element.id);
      });
      console.log(idList);
      this.$store.commit("getTreeList", idList);
      this.aboutJump(data);
      // this.tagTreeId = data.id
    },
    renderContent: function (h, { node, data, store }) {
      // console.log(data);
      // console.log(node);
      /**
            这个addElement等于的是一个自身的索引为0的东西
            我也不晓得这是个啥回来console看看吧
            大概率是一个dom结构或者是新增dom的东西
        */
      let addElement = arguments[0];
      // 这里判断这个rain类型，是和上面 children 有关系
      /*
            反正在最后返回了一个dom元素，一个i标签和俩span标签
            i标签添加个类名是放置icon图标，后面空span不知道干嘛的
            最后一个span是吧你要填写的文字传进去，他拿的是自身的索引为1的里面的
            我懂了，这个索引应该就是参数，这里拿到的是第二个参数中的数据
         */
      if (node.level === 1) {
        // debugger
        if (node.expanded == false) {
          return (
            // <div class="typeTitleBox" style="width: calc(100% - 40px);height: 50px;background: #f8f8f8;margin-top: 20px;padding: 0 20px;line-height: 50px;">
            //   <span class="title" style="font-size: 18px;color: #000;">{node.label}</span>
            //   <span class="typeTotal" style="font-size: 16px;color: #c22424;">(124578)</span>
            //   <span class="open" style="width: 32px;height: 14px;margin: 18px 0;text-align: center;font-size: 14px;line-height: 14px;color: #fff;float: right;background: #718fae;border-radius: 4px;display: inline-block;cursor: pointer;">展开</span>
            // </div>
            <div class="typeTitleBox" style="width:calc(100% - 20px)">
              <span class="title" style="font-size: 18px;color: #000;">
                {node.label}
              </span>
              <span class="typeTotal" style="font-size: 16px;color: #c22424;">
                ({data.count})
              </span>
              <span
                class="open"
                style="width: 32px;height: 20px;margin: 11px 0;text-align: center;font-size: 14px;line-height: 20px;color: #fff;float: right;background: #718fae;border-radius: 4px;display: inline-block;cursor: pointer;"
              >
                展开
              </span>
            </div>
          );
        } else {
          return (
            // <div class="typeTitleBox" style="width: calc(100% - 40px);height: 50px;background: #f8f8f8;margin-top: 20px;padding: 0 20px;line-height: 50px;">
            //   <span class="title" style="font-size: 18px;color: #000;">{node.label}</span>
            //   <span class="typeTotal" style="font-size: 16px;color: #c22424;">(124578)</span>
            //   <span class="open" style="width: 32px;height: 14px;margin: 18px 0;text-align: center;font-size: 14px;line-height: 14px;color: #fff;float: right;background: #718fae;border-radius: 4px;display: inline-block;cursor: pointer;">收起</span>
            // </div>
            <div class="typeTitleBox" style="width:calc(100% - 20px)">
              <span class="title" style="font-size: 18px;color: #000;">
                {node.label}
              </span>
              <span class="typeTotal" style="font-size: 16px;color: #c22424;">
                ({data.count})
              </span>
              <span
                class="open"
                style="width: 32px;height: 20px;margin: 11px 0;text-align: center;font-size: 14px;line-height: 20px;color: #fff;float: right;background: #718fae;border-radius: 4px;display: inline-block;cursor: pointer;"
              >
                收起
              </span>
            </div>
          );
        }
      } else if (node.level !== 1 && data.tags) {
        if (node.expanded == false) {
          return (
            <div
              class="tOne"
              style="padding-left:20px;line-height:36px;font-size:16px;color:#3d3d3d;font-family: SourceHanSansCN-Bold;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
            >
              <img
                src={addImg}
                style="width:15px;height:15px;margin-right:6px"
              />
              {node.label}
            </div>
          );
        } else {
          return (
            <div
              class="tOne"
              style="padding-left:20px;line-height:36px;font-size:16px;color:#3d3d3d;font-family: SourceHanSansCN-Bold;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
            >
              <img
                src={subImg}
                style="width:15px;height:15px;margin-right:6px"
              />
              {node.label}
            </div>
          );
        }
      } else {
        if (node.isCurrent) {
          return (
            <div
              class="tOne"
              style="padding-left:20px;line-height:36px;font-size:16px;color:#3d3d3d;font-family: SourceHanSansCN-Bold;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
            >
              <span>{node.label}</span>
            </div>
          );
        } else {
          return (
            <div
              class="tOne"
              style="padding-left:20px;line-height:36px;font-size:16px;color:#3d3d3d;font-family: SourceHanSansCN-Bold;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
            >
              <span>{node.label}</span>
            </div>
          );
        }
      }
    },
    // 《----------------标签树结束----------------》
    //联想词点击
    lenovoCheck(item) {
      //console.log(item);
      this.input = item.entry;
    },
    //搜索联想词
    fillHotWords: debounce(function () {
      if (this.input === "") {
        this.lenovoList = [];
        this.searchText = "";
        return;
      }
      //获取接口
      let data = {
        keyword: this.input,
        page: 1,
        size: 20,
      };
      keyLenovo(data)
        .then((res) => {
          if (res.status == 200 && res.data.status == 0) {
            this.lenovoList = res.data.rows;
            this.searchText = this.input;
            this.$nextTick(function () {
              this.mathLenovo();
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }, 500),
    //获取最近检索
    getSearchHistory() {
      let thatStr = this.$cookies.get("zsdy-gw-history");
      if (thatStr != null) {
        localStorage.setItem("zsdy-gw-history", thatStr);
      }
      let thatStroage = localStorage.getItem("zsdy-gw-history");
      if (thatStroage) {
        this.historyList = JSON.parse(thatStroage);
        this.$nextTick(function () {
          this.mathSearch();
        });
      }
    },
    //存储检索词
    addSearchHistory(text) {
      //获取缓存数据
      let thatHistory = [];
      let thatStr = this.$cookies.get("zsdy-gw-history");
      console.log(thatStr);
      thatStr = JSON.parse(thatStr);
      //判断是否存在
      if (thatStr) {
        thatHistory = thatStr;
        for (let i = thatHistory.length - 1; i > -1; i--) {
          if (thatHistory[i] == text) {
            thatHistory.splice(i, 1);
          }
        }
      }
      if (thatHistory.length >= 20) {
        thatHistory = thatHistory.slice(0, 9);
      }
      let thatText = encodeURIComponent(text);
      thatHistory.unshift(thatText);
      console.log(thatHistory);
      document.cookie = "zsdy-gw-history=" + JSON.stringify(thatHistory);
      this.searchText = "";
      this.getSearchHistory();
    },
    //历史记录点击
    historyClick(text) {
      this.input = text;
    },
    //计算最近检索词的长度
    mathSearch() {
      //获取
      let wNum = 0;
      let wArr = document.getElementsByClassName("textListHistory");
      for (let a = 0; a < wArr.length; a++) {
        wNum += wArr[a].clientWidth;
      }
      let wDom = document.getElementsByClassName("sHistoryScroll")[0];
      wDom.style.width = wNum + 20 + "px";
    },
    //计算联想词的长度
    mathLenovo() {
      //获取
      let wNum = 0;
      let wArr = document.getElementsByClassName("textList");
      for (let a = 0; a < wArr.length; a++) {
        wNum += wArr[a].clientWidth;
      }
      let wDom = document.getElementsByClassName("sLenovoScroll")[0];
      wDom.style.width = wNum + 20 + "px";
    },
  },
};
</script>
<style lang="scss" scoped>
.area {
  width: 1200px;
  margin: 0 auto;
  .antistop {
    width: 1200px;
    height: 92px;
    font-size: 14px;
    color: #333;
    background: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
    margin-bottom: 10px;
    img {
      display: inline-block;
      vertical-align: top;
      width: 105px;
      height: 48px;
      margin: 22px 20px;
    }
    .tagBox {
      display: inline-block;
      width: calc(100% - 165px);
      margin: 20px 20px 0 0;
      font-size: 14px;
      line-height: 14px;
      span {
        display: inline-block;
        margin-right: 20px;
        margin-bottom: 20px;
        cursor: pointer;
      }
    }
  }

  .searchBox {
    padding: 0 20px;
    width: 1160px;
    // height: 60px;
    box-shadow: 0 0 9px 0 rgba(6, 32, 103, 0.18);
    margin: 0 auto;
    background: #fff;
    margin-bottom: 10px;
  }
  .contentBox {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 50px;
    .treeBox {
      width: 340px;
      margin-right: 10px;
      min-height: 677px;
      background-color: #fff;
      box-shadow: 0px 0px 9px 0px rgba(6, 32, 103, 0.18);
      display: inline-block;
      vertical-align: top;
      .treeTypeBox {
        width: calc(100% - 40px);
        padding: 0 20px;
        padding-top: 10px;
        .typeTitleBox {
          width: calc(300px - 40px);
          height: 50px;
          background: #f8f8f8;
          margin-top: 20px;
          padding: 0 20px;
          line-height: 50px;
          .title {
            font-size: 18px;
            color: #000;
          }
          .typeTotal {
            font-size: 16px;
            color: #c22424;
          }
          .open {
            width: 32px;
            height: 20px;
            margin: 18px 0;
            text-align: center;
            font-size: 14px;
            line-height: 14px;
            color: #fff;
            float: right;
            background: #718fae;
            border-radius: 4px;
            display: inline-block;
            cursor: pointer;
          }
        }
        .typeBox:last-child {
          margin-bottom: 20px;
        }
      }
    }
    .rightBox {
      width: 850px;
      display: inline-block;
      vertical-align: top;
      // background-color: #fff;
      // box-shadow: 0px 0px 9px 0px rgba(6, 32, 103, 0.18);
      .zjgd {
        width: 850px;
        // height: 275px;
        background-color: #fff;
        box-shadow: 0px 0px 9px 0px rgba(6, 32, 103, 0.18);
        margin-bottom: 10px;
        .list {
          width: calc(100% - 40px);
          padding: 0 20px;
          ul {
            padding-left: 20px;
            li {
              line-height: 14px;
              font-size: 14px;
              color: #333;
              margin-top: 20px;
              cursor: pointer;
              .title {
                width: 700px;
                white-space: nowrap; // 文字不换行
                overflow: hidden; // 超出隐藏
                text-overflow: ellipsis;
                display: inline-block;
              }
              .time {
                float: right;
              }
            }
            li:last-child {
              padding-bottom: 20px;
            }
          }
        }
      }
      .DyAndJd {
        width: 850px;
        // height: 880px;
        .dy {
          width: 420px;
          // height: 880px;
          background-color: #fff;
          box-shadow: 0px 0px 9px 0px rgba(6, 32, 103, 0.18);
          display: inline-block;
          vertical-align: top;
          // margin-right: 10px;
          margin-bottom: 10px;
          .list {
            padding: 0 20px;
            .typeTitle {
              height: 18px;
              line-height: 18px;
              font-size: 18px;
              color: #000;
              font-weight: 700;
              margin-top: 20px;
              .typeTotal {
                font-size: 16px;
                color: #c22424;
              }
              .more {
                font-size: 14px;
                color: #0f59a4;
                float: right;
                cursor: pointer;
                font-weight: 400;
              }
            }
            ul {
              padding: 0 20px;
              li {
                margin-top: 20px;
                cursor: pointer;
                .title {
                  width: 100%;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: inline-block;
                  line-height: 1;
                  font-size: 14px;
                }
              }
              li:last-child {
                padding-bottom: 20px;
              }
            }
          }
        }
        .jd {
          width: 420px;
          // height: 880px;
          background-color: #fff;
          box-shadow: 0px 0px 9px 0px rgba(6, 32, 103, 0.18);
          display: inline-block;
          vertical-align: top;
          margin-bottom: 10px;
          .list {
            padding: 0 20px;
            .typeTitle {
              height: 18px;
              line-height: 18px;
              font-size: 18px;
              color: #000;
              font-weight: 700;
              margin-top: 20px;
              .typeTotal {
                font-size: 16px;
                color: #c22424;
              }
              .more {
                font-size: 14px;
                color: #0f59a4;
                float: right;
                cursor: pointer;
                font-weight: 400;
              }
            }
            ul {
              padding: 0 20px;
              li {
                margin-top: 20px;
                cursor: pointer;
                .title {
                  width: 100%;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: inline-block;
                  line-height: 1;
                  font-size: 14px;
                }
              }
              li:last-child {
                padding-bottom: 20px;
              }
            }
          }
        }
        .zt {
          width: 850px;
          // height: 275px;
          background-color: #fff;
          box-shadow: 0px 0px 9px 0px rgba(6, 32, 103, 0.18);
          margin-bottom: 10px;
          .list {
            width: calc(50% - 40px);
            padding: 0 20px;
            display: inline-block;
            vertical-align: top;
            .typeTitle {
              height: 18px;
              line-height: 18px;
              font-size: 18px;
              color: #000;
              font-weight: 700;
              margin-top: 20px;
              .typeTotal {
                font-size: 16px;
                color: #c22424;
              }
              .more {
                font-size: 14px;
                color: #0f59a4;
                float: right;
                cursor: pointer;
                font-weight: 400;
              }
            }
            ul {
              padding: 0 20px;
              li {
                margin-top: 20px;
                cursor: pointer;
                .title {
                  display: -webkit-box;
                  overflow: hidden;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  line-height: 1.5;
                  font-size: 14px;
                }
              }
              li:last-child {
                padding-bottom: 20px;
              }
            }
          }
        }
        .jjkc,
        .tdqs,
        .jcdl,
        .xwqy,
        .zhssf,
        .gxjsqy {
          width: 420px;
          // height: 320px;
          background-color: #fff;
          box-shadow: 0px 0px 9px 0px rgba(6, 32, 103, 0.18);
          display: inline-block;
          vertical-align: top;
          margin-bottom: 10px;
          .list {
            width: calc(100% - 40px);
            padding: 0 20px;
            ul {
              padding-left: 20px;
              li {
                line-height: 1.5;
                font-size: 14px;
                color: #333;
                margin-top: 20px;
                cursor: pointer;
                .title {
                  width: 100%;
                  display: -webkit-box;
                  overflow: hidden;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                }
                .time {
                  float: right;
                }
              }
              li:last-child {
                padding-bottom: 20px;
              }
            }
          }
        }
        .dy,
        .jjkc,
        .jcdl,
        .zhssf {
          margin-right: 10px;
        }
      }
    }
  }
}
.boxTitle {
  width: calc(100% - 20px);
  border-top: 4px solid #0f59a4;
  border-bottom: 1px solid #dcdcdc;
  line-height: 80px;
  font-size: 22px;
  display: inline-block;
  color: #0f59a4;
  padding-left: 20px;
  .typeTotal {
    font-size: 18px;
    color: #c22424;
    margin-left: 10px;
  }
  .more {
    font-size: 14px;
    color: #0f59a4;
    margin-right: 20px;
    float: right;
    cursor: pointer;
  }
}

ul li::marker {
  color: #0f59a4;
  font-size: 4px;
}
// 标签树
.el-tree > .el-tree-node {
  display: inline-block;
  min-width: 100%;
}
::v-deep .el-tree-node__content {
  font-size: 18px;
  color: #003fa8;
  line-height: 36px;
  height: 36px;
}
::v-deep .el-tree-node:focus > .el-tree-node__content {
  background: #eef8ff;
}
::v-deep .el-icon-caret-right:before {
  content: "";
}
::v-deep .el-tree-node__content > .el-tree-node__expand-icon {
  padding: 0;
}
::v-deep .tree_container .el-tree-node {
  padding-left: 0 !important;
}
::v-deep .el-tree-node.is-focusable .el-tree-node__content:first-child {
  // height: 50px !important;
}

::v-deep .el-tree > .el-tree-node > .el-tree-node__content {
  background: #f8f8f8;
  height: 50px;
}
::v-deep .el-tree > .el-tree-node {
  padding-bottom: 20px;
}

/**搜索联想 */
.searchLenovo {
  max-width: 710px;
  height: 40px;
  line-height: 40px;
  position: absolute;
  top: 64px;
  left: 0;
  .sLevovoTitle {
    width: 70px;
    height: 40px;
    float: left;
    color: #333333;
  }
  .sLevovoKey {
    min-width: 1px;
    max-width: 160px;
    height: 40px;
    float: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .sLevovoRight {
    width: 480px;
    height: 50px;
    float: left;
    overflow-x: auto;
    overflow-y: hidden;
    color: #888888;
    .textList {
      display: inline-block;
      padding: 0 10px;
      cursor: pointer;
    }
  }
}
.searchHistory {
  max-width: 710px;
  height: 40px;
  line-height: 40px;
  position: absolute;
  top: 64px;
  left: 0;
  .sHistoryTitle {
    width: 70px;
    height: 40px;
    float: left;
    color: #333333;
  }
  .sHistoryRight {
    width: 480px;
    height: 50px;
    float: left;
    overflow-x: auto;
    overflow-y: hidden;
    .sHistoryScroll {
      font-size: 15px;
    }
    .textListHistory {
      display: inline-block;
      padding: 0 10px;
      cursor: pointer;
      color: #888888;
    }
  }
}
/* 整个滚动条 */
::-webkit-scrollbar {
  width: 4px;
  height: 6px;
  background-color: #eeeeee;
}

/* 滚动条上的滚动滑块 */
::-webkit-scrollbar-thumb {
  background-color: #c6c6c6;
}
</style>
